import { useContext, useEffect } from "react";
import { ToolContext } from "../../../../context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const ProductWalkthrough = ({ pathname, end, start}) => {

    const {personalization_state} = useContext(ToolContext)
    const {walkthrough} = personalization_state

    const startTour = () =>{
        walkthrough.set((prev) => ({...prev, createProduct:true}))
    }

    const endTour = ()=>{
        walkthrough.set((prev) => ({...prev, createProduct:false}))
    }

    useEffect(() => {
        start("setup", "product-setup", startTour)
        //eslint-disable-next-line
    }, []);

    const steps =[
            {
                content: "Insert Product Name",
                placement: "right",
                target: "#walkthrough-product-step-1",
                disableBeacon: true
            },
            {
                content: "Select appropriate Unit of Measure",
                placement: "right",
                target: "#walkthrough-product-step-2",
                disableBeacon: true
            },
            {
                content: "Add description (optional)",
                placement: "bottom",
                target: "#walkthrough-product-step-3",
                disableBeacon: true
            },
            {
                content: "Click this to add more products",
                placement: "right",
                target: "#walkthrough-product-step-4",
                disableBeacon: true
            },
            {
                content: "Click Save once done",
                placement: "right",
                target: "#walkthrough-product-step-5",
                disableBeacon: true
            },
        ]

    return (
        <JoyrideWrapper 
            run={walkthrough.data.createProduct && window.location.pathname === pathname} 
            steps={steps} 
            setter={endTour} 
            end={end}
            p_name="product-setup" 
            featureName="setup"
        />
    );
}